/* Free fabric sample requests use Shopify's native contact form. */
(() => {
  if (window.KaliaFreeSwatches) return;
  const families = {roller:'Roller shades',zebra:'Zebra shades',cellular:'Cellular shades',roman:'Roman shades',sheer:'Sheer shades',venetian:'Mini blinds',drapery:'Drapery'};
  const text = (value, maximum = 300) => String(value ?? '').replace(/[\u0000-\u001f\u007f]/g, ' ').trim().slice(0, maximum);
  class KaliaFreeSwatches {
    static displayText(value) { return text(value).replace(/pers(?:ilux|ulix)/gi, 'KALIA'); }
    static displayCollection(value) { return this.displayText(value).replace(/^(?:A[- ]?OK|TWOPAGES|CURTARRA)\s+/i, ''); }
    static displaySpecification(value) { return this.displayText(value).replace(/\bOpennss\b/gi, 'Openness'); }
    static limit(value) { const number = Number(value); return Number.isSafeInteger(number) && number > 0 ? Math.min(number,30) : 30; }
    static safeUrl(value) {
      const raw = text(value, 2000);
      if (!raw) return '';
      try { const url = new URL(raw, window.location?.origin || 'https://example.invalid'); return /^https?:$/.test(url.protocol) ? raw : ''; }
      catch (_) { return ''; }
    }
    static customizationUrl(swatch, shopRoot = '/') {
      const handle = text(swatch?.productHandle, 250), sku = text(swatch?.sourceSkuId, 200);
      if (!/^[a-z0-9][a-z0-9-]*$/.test(handle) || !sku) return '';
      const origin = window.location?.origin || 'https://example.invalid';
      try {
        const root = new URL(shopRoot, origin);
        if (root.origin !== origin || root.search || root.hash) return '';
        root.pathname = root.pathname.replace(/\/?$/, '/');
        const url = new URL(`products/${handle}`, root);
        url.searchParams.set('swatch', sku);
        return url.pathname + url.search;
      } catch (_) { return ''; }
    }
    static normalizeCatalog(catalog) {
      if (!catalog || catalog.version !== 1 || !Array.isArray(catalog.swatches)) throw new Error('Fabric swatches are unavailable.');
      const seen = new Set(), swatches = [];
      catalog.swatches.forEach(item => {
        if (!item || !families[item.family]) return;
        const id = text(item.id, 200), productHandle = text(item.productHandle, 250), sourceSkuId = text(item.sourceSkuId, 200);
        if (!id || !productHandle || !sourceSkuId || seen.has(id)) return;
        seen.add(id);
        const sourceOptions = Object.fromEntries(Object.entries(item.sourceOptions && typeof item.sourceOptions === 'object' && !Array.isArray(item.sourceOptions) ? item.sourceOptions : {}).map(([name,value]) => [text(name,100),text(value)]).filter(([name,value]) => name && value));
        const specification = text(item.specification) || Object.entries(sourceOptions).filter(([name]) => !/^colou?r$/i.test(name)).map(([name,value]) => `${name}: ${value}`).join(' · ');
        swatches.push({id, family:item.family, familyLabel:text(item.familyLabel) || families[item.family], collection:text(item.collection), productHandle, sourceSkuId, sourceSku:text(item.sourceSku || item.colorCode), colorCode:text(item.colorCode), sourceOptions, specification, color:text(item.color), name:text(item.name), image:this.safeUrl(item.image), url:this.safeUrl(item.url)});
      });
      if (!swatches.length) throw new Error('Fabric swatches are unavailable.');
      return swatches;
    }
    static requestedSample(url) {
      try {
        const values = new URL(url, window.location?.origin || 'https://example.invalid').searchParams.getAll('sample');
        return values.length === 1 && /^[A-Za-z0-9][A-Za-z0-9:_-]{0,199}$/.test(values[0]) ? values[0] : null;
      } catch (_) { return null; }
    }
    static filter(swatches, query = '', filter = 'all') {
      const words = text(query).toLocaleLowerCase().split(/\s+/).filter(Boolean);
      return swatches.filter(swatch => {
        const familyMatches = filter === 'all' || (filter === 'shades' ? swatch.family !== 'drapery' : swatch.family === filter);
        const haystack = [swatch.family, swatch.familyLabel, swatch.collection, swatch.productHandle, swatch.sourceSkuId, swatch.sourceSku, swatch.colorCode, swatch.specification, ...Object.values(swatch.sourceOptions || {}), swatch.color, swatch.name].join(' ').toLocaleLowerCase();
        return familyMatches && words.every(word => haystack.includes(word));
      });
    }
    static serialize(swatches, customer = {}, maximum = 30, shopRoot = '/') {
      const limit = this.limit(maximum);
      if (swatches.length > limit) throw new Error(`Choose up to ${limit} swatches.`);
      const lines = ['Kalia Free Swatch Request', `Selected swatches: ${swatches.length} of ${limit}`, ''];
      swatches.forEach((swatch, index) => {
        lines.push(`${index + 1}. ${text(swatch.name) || text(swatch.color) || text(swatch.collection)}`, `   Selection ID: ${text(swatch.id,200)}`, `   Family: ${text(swatch.familyLabel) || text(swatch.family)}`, `   Collection: ${text(swatch.collection)}`, `   Source product handle: ${text(swatch.productHandle,250)}`, `   Source SKU ID: ${text(swatch.sourceSkuId,200)}`, `   Source SKU / code: ${text(swatch.sourceSku)}`, `   Color: ${text(swatch.color)}`);
        if (swatch.specification) lines.push(`   Specification: ${text(swatch.specification)}`);
        Object.entries(swatch.sourceOptions || {}).forEach(([name,value]) => lines.push(`   Source option — ${text(name,100)}: ${text(value)}`));
        if (this.safeUrl(swatch.url)) lines.push(`   Product URL: ${this.safeUrl(swatch.url)}`);
        const customize = this.customizationUrl(swatch, shopRoot);
        if (customize) lines.push(`   Customize this product and color: ${new URL(customize, window.location?.origin || 'https://example.invalid').href}`);
        lines.push('');
      });
      const fields = [['first_name','First name'],['last_name','Last name'],['email','Email'],['address1','Address line 1'],['address2','Address line 2'],['city','City'],['province','State / province'],['zip','ZIP / postal code'],['country','Country'],['phone','Phone']];
      lines.push('Customer and delivery details');
      fields.forEach(([key,label]) => { const value = text(customer[key], 500); if (value) lines.push(`${label}: ${value}`); });
      const notes = String(customer.notes ?? '').replace(/\u0000/g,'').trim().slice(0,5000);
      if (notes) lines.push('', 'Customer notes:', notes);
      lines.push('', 'First-pack standard shipping: United States free; Canada US$7.99.', 'Our team replies within 1 business day. In-stock swatches dispatch within 2 business days after availability and the mailing address are confirmed.', 'For Canada, the team sends a Shopify payment link for sample shipping. Shipping payment must be completed before dispatch.', 'This is a sample request; no payment is collected by this form and shipment is confirmed separately.');
      return lines.join('\n');
    }
    constructor(root, options = {}) {
      this.root = root;
      this.form = root.querySelector('[data-swatch-form]');
      this.grid = root.querySelector('[data-swatch-grid]');
      this.search = root.querySelector('[data-swatch-search]');
      this.filterInput = root.querySelector('[data-swatch-filter]');
      this.categoryButtons = root.querySelectorAll('[data-swatch-category]');
      this.activeFilter = this.filterInput?.value || 'all';
      this.shopRoot = root.dataset.shopRoot || '/';
      this.storageKey = 'kalia.free-swatches.selection.v1';
      this.lastRequestKey = 'kalia.free-swatches.last-request.v1';
      this.more = root.querySelector('[data-swatch-more]');
      this.count = root.querySelector('[data-swatch-count]');
      this.live = root.querySelector('[data-swatch-live]');
      this.empty = root.querySelector('[data-swatch-empty]');
      this.list = root.querySelector('[data-selected-swatches]');
      this.summary = root.querySelector('[data-selection-summary]');
      this.body = root.querySelector('[data-contact-body]');
      this.submit = root.querySelector('[data-request-submit]');
      this.error = root.querySelector('[data-swatch-error]');
      this.maximum = this.constructor.limit(root.dataset.maxSwatches);
      this.pageSize = 24;
      this.visibleLimit = this.pageSize;
      this.swatches = [];
      this.byId = new Map();
      this.selected = new Map();
      this.selectionRevision = 0;
      this.initialization = 0;
      this.requestedSampleId = this.constructor.requestedSample(options.url || window.location?.href || window.location?.origin || '');
      this.cards = new Map();
      this.fetch = options.fetch || (typeof window.fetch === 'function' ? window.fetch.bind(window) : null);
      if (root.querySelector('[data-request-success]')) {
        if (root.querySelector('[data-success-fabrics]')) this.ready = this.restoreSuccessFabrics();
        else this.rememberSelection([]);
        return;
      }
      if (!this.form || !this.grid || !this.body || !this.submit) return;
      this.addressCountry = root.querySelector('[data-swatch-address-country]');
      this.addressRegion = root.querySelector('[data-swatch-address-region]');
      this.addressPostal = root.querySelector('[data-swatch-address-postal]');
      this.updateAddressFields();
      if (this.more) { this.more.type = 'button'; this.more.hidden = true; }
      this.submit.disabled = true;
      this.bind();
      if (options.autoInitialize !== false) this.ready = this.initialize();
    }
    bind() {
      this.addressCountry?.addEventListener('change', () => { this.updateAddressFields(); this.updateBody(); });
      this.search?.addEventListener('input', () => { this.visibleLimit = this.pageSize; this.renderGrid(); });
      this.filterInput?.addEventListener('change', () => this.setFilter(this.filterInput.value));
      this.categoryButtons.forEach(button => button.addEventListener('click', () => this.setFilter(button.dataset.swatchCategory)));
      this.more?.addEventListener('click', event => this.showMore(event));
      this.grid.addEventListener('click', event => {
        const button = event.target.closest('[data-swatch-id]');
        if (button && this.grid.contains(button)) this.toggle(button.dataset.swatchId);
      });
      this.list?.addEventListener('click', event => {
        const button = event.target.closest('[data-remove-swatch]');
        if (button && this.list.contains(button)) this.toggle(button.dataset.removeSwatch, {id:button.dataset.removeSwatch,kind:'remove',index:[...this.list.querySelectorAll('[data-remove-swatch]')].indexOf(button),preventScroll:event.detail !== 0});
      });
      this.form.addEventListener('input', () => this.updateBody());
      this.form.addEventListener('change', () => this.updateBody());
      this.form.addEventListener('submit', event => {
        if (!this.selected.size) {
          event.preventDefault();
          this.showError('Choose at least one fabric swatch before sending your request.', true);
          return;
        }
        if (this.selected.size > this.maximum) {
          event.preventDefault();
          this.showError(`Choose up to ${this.maximum} swatches. Remove the extra swatches before sending your request.`, true);
          return;
        }
        this.updateBody();
        // Shopify validates customer fields, posts the request, and owns the success state.
      });
    }
    updateAddressFields() {
      if (!this.addressCountry || !this.addressRegion || !this.addressPostal) return;
      const country = this.addressCountry.value, canada = country === 'Canada';
      const options = [...this.addressRegion.querySelectorAll('option[data-swatch-country]')];
      options.forEach(option => { option.disabled = option.dataset.swatchCountry !== country; option.hidden = option.disabled; });
      if (!options.some(option => !option.disabled && option.value === this.addressRegion.value)) this.addressRegion.value = '';
      const regionLabel = this.root.querySelector('[data-swatch-region-label]');
      const postalLabel = this.root.querySelector('[data-swatch-postal-label]');
      const postalHelp = this.root.querySelector('[data-swatch-postal-help]');
      if (regionLabel) regionLabel.textContent = canada ? 'Province / territory' : 'State';
      if (postalLabel) postalLabel.textContent = canada ? 'Postal code' : 'ZIP code';
      if (postalHelp) postalHelp.textContent = canada ? 'Enter your Canadian postal code, for example K1A 0B1.' : 'Enter a 5-digit U.S. ZIP code or ZIP+4.';
      this.addressPostal.setAttribute('pattern', canada ? '[A-Za-z][0-9][A-Za-z] ?[0-9][A-Za-z][0-9]' : '[0-9]{5}(-[0-9]{4})?');
      this.addressPostal.setAttribute('inputmode', canada ? 'text' : 'numeric');
      this.addressPostal.setAttribute('title', canada ? 'Enter a Canadian postal code such as K1A 0B1.' : 'Enter a 5-digit U.S. ZIP code or ZIP+4.');
    }
    async initialize() {
      const initialization = ++this.initialization, revision = this.selectionRevision;
      this.root.dataset.swatchesState = 'loading';
      try {
        const catalog = await this.loadCatalog();
        if (initialization !== this.initialization) return;
        this.swatches = this.constructor.normalizeCatalog(catalog);
        this.byId = new Map(this.swatches.map(swatch => [swatch.id,swatch]));
        let requestState = '', restoredExcess = false;
        // A slow catalog response must not restore older choices over a customer's new selection.
        if (revision === this.selectionRevision) {
          try {
            const stored = JSON.parse(window.sessionStorage.getItem(this.storageKey) || '[]');
            if (Array.isArray(stored)) {
              const validIds = [...new Set(stored.filter(id => typeof id === 'string' && this.byId.has(id)))];
              restoredExcess = validIds.length > this.maximum;
              validIds.slice(0,this.maximum).forEach(id => this.selected.set(id,this.byId.get(id)));
            }
          } catch (_) { /* Functional selection storage is optional. */ }
          requestState = this.applyRequestedSample(this.requestedSampleId);
        }
        this.root.dataset.swatchesState = 'ready';
        this.renderGrid();
        this.renderSelection();
        if (requestState === 'full') this.showError(`Your ${this.maximum} swatches are saved. Remove one to add this swatch.`);
        else if (requestState === 'unavailable') this.showError('This swatch is unavailable. Choose another below.');
        else if (restoredExcess) this.showError(`Your first ${this.maximum} saved swatches were restored. The remaining swatches exceed the request limit and were not added. Review your selection before sending.`);
      } catch (_) {
        if (initialization !== this.initialization) return;
        this.root.dataset.swatchesState = 'error';
        this.submit.disabled = true;
        this.showError('We could not load the fabric swatches. Please refresh this page or contact Kalia for help.');
      }
    }
    async loadCatalog() {
      const inline = this.root.querySelector('[data-swatch-catalog]');
      if (inline) return JSON.parse(inline.textContent);
      if (!this.fetch || !this.root.dataset.catalogUrl) throw new Error('Fabric swatches are unavailable.');
      const response = await this.fetch(this.root.dataset.catalogUrl, {headers:{Accept:'application/json'}});
      if (!response.ok) throw new Error('Fabric swatches are unavailable.');
      return response.json();
    }
    storedIds(key) {
      try {
        const value = JSON.parse(window.sessionStorage.getItem(key) || '[]');
        return Array.isArray(value) ? [...new Set(value.filter(id => typeof id === 'string' && id.length > 0 && id.length <= 200))].slice(0,this.maximum) : [];
      } catch (_) { return []; }
    }
    async restoreSuccessFabrics() {
      // Only Shopify's server-rendered success branch reaches this path. These links are
      // shopping aids, not shipment confirmation. Store catalog IDs, never address details.
      const currentIds = this.storedIds(this.storageKey);
      const ids = currentIds.length ? currentIds : this.storedIds(this.lastRequestKey);
      this.rememberSelection([]);
      const panel = this.root.querySelector('[data-success-fabrics]');
      const list = this.root.querySelector('[data-success-swatch-links]');
      if (!ids.length || !panel || !list) return;
      try {
        const swatches = this.constructor.normalizeCatalog(await this.loadCatalog());
        const byId = new Map(swatches.map(swatch => [swatch.id,swatch]));
        const saved = ids.map(id => byId.get(id)).filter(swatch => swatch && this.constructor.customizationUrl(swatch,this.shopRoot));
        if (!saved.length) return;
        try { window.sessionStorage.setItem(this.lastRequestKey,JSON.stringify(saved.map(swatch => swatch.id))); } catch (_) { /* Optional convenience. */ }
        list.replaceChildren();
        const savedText = [];
        saved.forEach(swatch => {
          const item = this.element('li','kfs-saved-fabric');
          const link = this.customizationLink(swatch,'kfs-saved-fabric-link');
          const label = [this.constructor.displayCollection(swatch.collection),this.constructor.displayText(swatch.color || swatch.name),swatch.sourceSku ? `Code ${this.constructor.displayText(swatch.sourceSku)}` : ''].filter(Boolean).join(' · ');
          link.textContent = `${label} — Customize →`;
          item.append(link); list.append(item);
          savedText.push(`${label}\n${new URL(this.constructor.customizationUrl(swatch,this.shopRoot),window.location.origin).href}`);
        });
        const links = this.root.querySelector('[data-saved-fabric-links]');
        const wrapper = this.root.querySelector('[data-saved-links-wrap]');
        const button = this.root.querySelector('[data-save-fabric-links]');
        if (links) links.value = savedText.join('\n\n');
        if (links && wrapper && button) button.addEventListener('click', () => {
          wrapper.hidden = false;
          links.focus();
          links.select?.();
          button.textContent = 'Fabric links ready to copy';
        });
        panel.hidden = false;
      } catch (_) { /* A catalog or storage failure must not hide Shopify's confirmed receipt. */ }
    }
    applyRequestedSample(id) {
      if (!id) return '';
      const swatch = this.byId.get(id);
      if (!swatch) return 'unavailable';
      if (this.selected.has(id)) return 'existing';
      if (this.selected.size >= this.maximum) return 'full';
      this.selected.set(id,swatch);
      this.rememberSelection();
      return 'selected';
    }
    element(tag, className, value) {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (value !== undefined) node.textContent = value;
      return node;
    }
    label(swatch) { return [this.constructor.displayText(swatch.color || swatch.name), this.constructor.displaySpecification(swatch.specification), this.constructor.displayCollection(swatch.collection), this.constructor.displayText(swatch.familyLabel)].filter(Boolean).join(' · '); }
    customizationLink(swatch, className) {
      const url = this.constructor.customizationUrl(swatch,this.shopRoot);
      if (!url) return null;
      const link = this.element('a',className);
      link.href = url;
      link.dataset.swatchCustomize = swatch.id;
      link.setAttribute('aria-label',`Customize ${this.constructor.displayCollection(swatch.collection)} — ${this.constructor.displayText(swatch.color || swatch.name)}${swatch.sourceSku ? ` (${swatch.sourceSku})` : ''}`);
      return link;
    }
    image(swatch) {
      const frame = this.element('span','kfs-card__media');
      if (swatch.image) {
        const image = this.element('img'); image.src = swatch.image; image.alt = `${this.constructor.displayText(swatch.color || swatch.name)} fabric swatch`; image.loading = 'lazy'; image.width = 360; image.height = 360;
        frame.append(image);
      } else frame.append(this.element('span','kfs-card__image-fallback','Fabric swatch'));
      return frame;
    }
    setFilter(value) {
      if (!['all','shades',...Object.keys(families)].includes(value)) return;
      this.activeFilter = value;
      if (this.filterInput) this.filterInput.value = value;
      this.visibleLimit = this.pageSize;
      this.renderGrid();
    }
    renderCategories() {
      const matching = this.constructor.filter(this.swatches,this.search?.value || '','all');
      const counts = {all:matching.length,shades:0};
      matching.forEach(swatch => { counts[swatch.family] = (counts[swatch.family] || 0) + 1; if (swatch.family !== 'drapery') counts.shades += 1; });
      this.categoryButtons.forEach(button => {
        const value = button.dataset.swatchCategory, count = counts[value] || 0;
        const label = button.querySelector('[data-category-label]')?.textContent || value;
        const countNode = button.querySelector('[data-category-count]');
        if (countNode) countNode.textContent = String(count);
        button.setAttribute('aria-pressed',String(value === this.activeFilter));
        button.setAttribute('aria-label',`${label}: ${count} ${count === 1 ? 'swatch' : 'swatches'}`);
        button.disabled = count === 0 && value !== this.activeFilter;
      });
    }
    focusNode(node, preventScroll = true, settle = true) {
      if (!node || node.isConnected === false || node.disabled || node.hidden || node.closest?.('[hidden], [inert]') || typeof node.focus !== 'function') return false;
      node.focus({preventScroll});
      const focused = document.activeElement === node, revision = this.focusRevision = (this.focusRevision || 0) + 1;
      // The image viewer wraps new cards after render. A DOM move may blur a descendant.
      if (focused && settle && typeof window.queueMicrotask === 'function') window.queueMicrotask(() => window.queueMicrotask(() => {
        if (revision === this.focusRevision && document.activeElement === document.body) this.focusNode(node,true,false);
      }));
      return focused;
    }
    focusCard(id, kind = 'customize', preventScroll = true) {
      const entry = this.cards.get(id);
      if (!entry) return false;
      const customize = entry.card.querySelector('[data-swatch-customize]');
      const targets = kind === 'select' ? [entry.button,customize] : [customize,entry.button];
      return targets.some(node => this.focusNode(node,preventScroll));
    }
    focusBrowsingFallback(preventScroll = true, selection = false) {
      if (selection) {
        const heading = this.list?.closest('.kfs-selection')?.querySelector('h2') || this.summary;
        if (heading) { heading.tabIndex = -1; if (this.focusNode(heading,preventScroll)) return; }
      }
      const targets = [this.search,this.more,...this.categoryButtons];
      targets.some(node => this.focusNode(node,preventScroll));
    }
    gridFocus() {
      const active = document.activeElement;
      if (!active || !this.grid.contains(active)) return null;
      const card = active.closest('[data-swatch-card]');
      return card ? {id:card.dataset.swatchCard,kind:active.closest('[data-swatch-id]') ? 'select' : 'customize'} : null;
    }
    selectionFocus() {
      const active = document.activeElement;
      if (!active || !this.list?.contains(active)) return null;
      const item = active.closest('.kfs-selected-item'), remove = item?.querySelector('[data-remove-swatch]');
      return remove ? {id:remove.dataset.removeSwatch,kind:active.closest('[data-swatch-customize]') ? 'customize' : 'remove',index:[...this.list.querySelectorAll('[data-remove-swatch]')].indexOf(remove),preventScroll:true} : null;
    }
    restoreSelectionFocus(context) {
      if (!context || !this.list) return;
      const removes = [...this.list.querySelectorAll('[data-remove-swatch]')];
      const same = removes.find(button => button.dataset.removeSwatch === context.id);
      if (same) {
        const customize = same.closest('.kfs-selected-item')?.querySelector('[data-swatch-customize]');
        if (context.kind === 'customize' && this.focusNode(customize,context.preventScroll)) return;
        if (this.focusNode(same,context.preventScroll)) return;
      }
      const next = removes[Math.min(Math.max(0,context.index),removes.length - 1)];
      if (this.focusNode(next,context.preventScroll) || this.focusCard(context.id,'select',context.preventScroll)) return;
      this.focusBrowsingFallback(context.preventScroll,true);
    }
    showMore(event) {
      const previous = new Set(this.cards.keys()), focused = document.activeElement === this.more;
      this.visibleLimit += this.pageSize;
      this.renderGrid();
      // Keyboard and assistive clicks enter new content; pointer clicks keep their place.
      if (event?.detail !== 0 && !(focused && this.more?.hidden)) return;
      const added = [...this.cards.keys()].find(id => !previous.has(id));
      const preventScroll = event?.detail !== 0;
      if (added && this.focusCard(added,'customize',preventScroll)) return;
      if (!this.focusNode(this.more,preventScroll)) this.focusBrowsingFallback(preventScroll);
    }
    renderGrid() {
      const focused = this.gridFocus();
      const filtered = this.constructor.filter(this.swatches,this.search?.value || '',this.activeFilter);
      // Keep the sample requested from a product visible without asking for its color again.
      if (!this.search?.value && this.selected.has(this.requestedSampleId)) {
        const index = filtered.findIndex(swatch => swatch.id === this.requestedSampleId);
        if (index > 0) filtered.unshift(filtered.splice(index,1)[0]);
      }
      const visible = filtered.slice(0,this.visibleLimit);
      this.renderCategories();
      this.grid.replaceChildren(); this.cards.clear();
      visible.forEach(swatch => {
        const card = this.element('article','kfs-card'); card.dataset.swatchCard = swatch.id;
        const product = this.customizationLink(swatch,'kfs-card__product') || this.element('div','kfs-card__product');
        const copy = this.element('span','kfs-card__copy');
        copy.append(this.element('span','kfs-card__family',this.constructor.displayText(swatch.familyLabel)));
        if (swatch.collection) copy.append(this.element('span','kfs-card__collection',this.constructor.displayCollection(swatch.collection)));
        copy.append(this.element('strong','kfs-card__color',this.constructor.displayText(swatch.color || swatch.name)));
        if (swatch.specification) copy.append(this.element('span','kfs-card__specification',this.constructor.displaySpecification(swatch.specification)));
        if (swatch.sourceSku) copy.append(this.element('small','kfs-card__code',`Code ${swatch.sourceSku}`));
        if (product.tagName === 'A') copy.append(this.element('span','kfs-card__customize','Customize →'));
        product.append(this.image(swatch),copy);
        const button = this.element('button','kfs-card__action'); button.type = 'button'; button.dataset.swatchId = swatch.id;
        card.append(product,button); this.grid.append(card);
        this.cards.set(swatch.id,{card,button,action:button,swatch});
      });
      if (this.empty) this.empty.hidden = filtered.length !== 0;
      if (this.more) { this.more.hidden = visible.length >= filtered.length; this.more.disabled = this.more.hidden; }
      this.updateCards();
      if (this.live) this.live.textContent = `${visible.length} of ${filtered.length} fabric ${filtered.length === 1 ? 'swatch' : 'swatches'} shown. ${this.selected.size} of ${this.maximum} selected.`;
      if (focused && !this.focusCard(focused.id,focused.kind)) this.focusBrowsingFallback();
    }
    updateCards() {
      this.cards.forEach(({card,button,action,swatch},id) => {
        const selected = this.selected.has(id), limited = !selected && this.selected.size >= this.maximum;
        card.dataset.selected = String(selected); button.setAttribute('aria-pressed',String(selected)); button.setAttribute('aria-label',`${selected ? 'Remove sample' : 'Select sample'} ${this.label(swatch)}`); button.disabled = limited;
        action.textContent = selected ? 'Sample selected ✓' : 'Select sample +';
      });
    }
    toggle(id, focus) {
      if (this.selected.has(id)) this.selected.delete(id);
      else {
        const swatch = this.byId.get(id);
        if (!swatch) return false;
        if (this.selected.size >= this.maximum) { if (this.live) this.live.textContent = `You can choose up to ${this.maximum} swatches. Remove one to choose another.`; return false; }
        this.selected.set(id,swatch);
      }
      this.selectionRevision += 1;
      this.showError(''); this.updateCards(); this.renderSelection(focus);
      this.rememberSelection();
      if (this.live) this.live.textContent = `${this.selected.size} of ${this.maximum} fabric swatches selected.${this.selected.size >= this.maximum ? ' Remove one to choose another.' : ''}`;
      return true;
    }
    rememberSelection(ids = [...this.selected.keys()]) {
      try { window.sessionStorage.setItem(this.storageKey,JSON.stringify(ids)); } catch (_) { /* Selection still works when storage is unavailable. */ }
    }
    renderSelection(focus = this.selectionFocus()) {
      const counts = this.root.querySelectorAll?.('[data-swatch-count]') || (this.count ? [this.count] : []);
      counts.forEach(count => { count.textContent = `${this.selected.size} / ${this.maximum}`; });
      if (this.summary) this.summary.textContent = this.selected.size ? `${this.selected.size} ${this.selected.size === 1 ? 'swatch' : 'swatches'} selected.` : `Choose up to ${this.maximum} swatches.`;
      if (this.list) {
        this.list.replaceChildren();
        this.selected.forEach(swatch => {
          const item = this.element('li','kfs-selected-item');
          const copy = this.customizationLink(swatch,'kfs-selected-copy') || this.element('span','kfs-selected-copy'); copy.append(this.element('strong',null,this.constructor.displayText(swatch.color || swatch.name)),this.element('span',null,this.constructor.displayCollection(swatch.collection) || this.constructor.displayText(swatch.familyLabel)));
          if (swatch.specification) copy.append(this.element('span','kfs-selected-specification',this.constructor.displaySpecification(swatch.specification)));
          if (swatch.sourceSku) copy.append(this.element('small',null,`Code ${swatch.sourceSku}`));
          if (copy.tagName === 'A') copy.append(this.element('span','kfs-selected-customize','Customize →'));
          const remove = this.element('button','kfs-selected-remove','Remove'); remove.type = 'button'; remove.dataset.removeSwatch = swatch.id; remove.setAttribute('aria-label',`Remove ${this.label(swatch)}`);
          item.append(this.image(swatch),copy,remove); this.list.append(item);
        });
      }
      // Leave the native submit available so an empty request receives an accessible explanation.
      this.submit.disabled = this.root.dataset.swatchesState !== 'ready';
      this.updateBody();
      this.restoreSelectionFocus(focus);
    }
    customer() {
      const values = {};
      ['first_name','last_name','email','address1','address2','city','province','zip','country','phone','notes'].forEach(name => {
        const field = this.form.elements.namedItem?.(name) || this.form.elements.namedItem?.(`contact[${name}]`) || this.form.elements[name] || this.form.elements[`contact[${name}]`];
        values[name] = typeof field?.value === 'string' ? field.value : '';
      });
      return values;
    }
    updateBody() { this.body.value = this.constructor.serialize([...this.selected.values()],this.customer(),this.maximum,this.shopRoot); }
    showError(message, focus = false) {
      if (!this.error) return;
      this.error.textContent = message; this.error.hidden = !message;
      if (focus && message) { this.error.tabIndex = -1; this.error.focus(); }
    }
  }
  window.KaliaFreeSwatches = KaliaFreeSwatches;
  const start = () => document.querySelectorAll('[data-free-swatches]').forEach(root => new KaliaFreeSwatches(root));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true}); else start();
})();
